"use client";

import React from "react";
import { Check } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  id: "finance",
  title: "Financieel inzicht",
  description: "Grip op cijfers, marges en rendement",
  link: "/FinancePage",
  image: "https://goodvibeshospitality.nl/wp-content/uploads/2026/05/025_StephenVBFotografie_delichttoren_20231026-scaled.jpg?v=mnx3w1xsyb",
  srcset: "https://goodvibeshospitality.nl/wp-content/uploads/2026/05/025_StephenVBFotografie_delichttoren_20231026-scaled.jpg?v=2u3zco6f3lj-wvc-srcset",
  sizes: "https://goodvibeshospitality.nl/wp-content/uploads/2026/05/025_StephenVBFotografie_delichttoren_20231026-scaled.jpg?v=8teodf89qs-wvc-sizes",
  bullet1: "Marge- en kostenoptimalisatie",
  bullet2: "Financiële prognoses en sturing",
  bullet3: "Optimalisatie van (inkoop)-contracten"
}, {
  id: "operations",
  title: "Operationeel",
  description: "Slimmere processen en hogere marges",
  link: "/OperationsPage",
  image: "https://goodvibeshospitality.nl/wp-content/uploads/2026/05/header-foto-scaled.jpg?v=jui9ziztku",
  srcset: "https://goodvibeshospitality.nl/wp-content/uploads/2026/05/header-foto-scaled.jpg?v=mtzrleb9zo9-wvc-srcset",
  sizes: "https://goodvibeshospitality.nl/wp-content/uploads/2026/05/header-foto-scaled.jpg?v=fces5lfvmte-wvc-sizes",
  bullet1: "Efficiëntere routing en werkprocessen",
  bullet2: "Grip op inkoop en kostprijzen",
  bullet3: "Voorraad- en dervingscontrole"
}, {
  id: "hr",
  title: "Personeelszaken",
  description: "Meer grip op personeel en loonkosten",
  link: "/HumanResourcesPage",
  image: "https://goodvibeshospitality.nl/wp-content/uploads/2026/05/De-Vaste-Clique-7-scaled.jpg?v=6ku5i2acte",
  srcset: "https://goodvibeshospitality.nl/wp-content/uploads/2026/05/De-Vaste-Clique-7-scaled.jpg?v=hg2o3izd7qb-wvc-srcset",
  sizes: "https://goodvibeshospitality.nl/wp-content/uploads/2026/05/De-Vaste-Clique-7-scaled.jpg?v=rpqhb8nsail-wvc-sizes",
  bullet1: "Contractbeheer en verloning",
  bullet2: "Sturing op loonkosten",
  bullet3: "Structuur in HR-processen"
}, {
  id: "marketing",
  title: "Marketing",
  description: "Meer zichtbaarheid, gasten en omzet",
  link: "/MarketingPage",
  image: "https://goodvibeshospitality.nl/wp-content/uploads/2026/05/Fotos-Lichttoren-18-04-2023-24-scaled.jpg?v=nun3v9xjio",
  srcset: "https://goodvibeshospitality.nl/wp-content/uploads/2026/05/Fotos-Lichttoren-18-04-2023-24-scaled.jpg?v=xtguraazun-wvc-srcset",
  sizes: "https://goodvibeshospitality.nl/wp-content/uploads/2026/05/Fotos-Lichttoren-18-04-2023-24-scaled.jpg?v=ttje4x4mev-wvc-sizes",
  bullet1: "Social media beheer",
  bullet2: "Professionele contentcreatie",
  bullet3: "Actiegerichte campagnes"
}, {
  id: "admin",
  title: "Administratie",
  description: "Rust, overzicht en betrouwbare cijfers",
  link: "/AdministrationPage",
  image: "https://goodvibeshospitality.nl/wp-content/uploads/2026/05/De-Vaste-Clique-68-scaled.jpg?v=3svrrz01x9l",
  srcset: "https://goodvibeshospitality.nl/wp-content/uploads/2026/05/De-Vaste-Clique-68-scaled.jpg?v=hf8cwymi1a-wvc-srcset",
  sizes: "https://goodvibeshospitality.nl/wp-content/uploads/2026/05/De-Vaste-Clique-68-scaled.jpg?v=4yv2ah5mo38-wvc-sizes",
  bullet1: "Factuurverwerking",
  bullet2: "Omzetcontrole en kassakoppelingen",
  bullet3: "BTW-aangiftes en jaarrekening"
}];
function ServiceCard({
  service,
  index
}: {
  service: typeof services[0];
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <div ref={ref} data-index={index} className={`transition-all duration-1000 ease-in-out-quint ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
    transitionDelay: `${index * 150}ms`
  }}>
      <div className="block h-full group">
        <Card className="h-full flex flex-col border border-primary/10 bg-white/70 backdrop-blur-2xl shadow-sm hover:shadow-xl transition-all duration-500 rounded-xl overflow-hidden">
          <div className="aspect-[16/9] w-full overflow-hidden relative">
            <img src={service.image} data-wvc-srcset={service.srcset} data-wvc-sizes={service.sizes} alt={service.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
          </div>
          <CardHeader className="pb-2 pt-6 px-6">
            <CardTitle className="text-xl font-bold text-foreground group-hover:text-primary transition-colors duration-300">
              {service.title}
            </CardTitle>
            <CardDescription className="text-sm mt-2 text-muted-foreground leading-relaxed">
              {service.description}
            </CardDescription>
          </CardHeader>
          
        </Card>
      </div>
    </div>;
}
export default function Expertisegrid() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="259713" id="expertisegrid" className="bg-background text-foreground relative overflow-hidden ![padding:0px_0px_10px_0px]">
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div ref={headerRef} className="flex flex-col items-center text-center mb-8 transition-all duration-1000 ease-in-out-quint opacity-100 translate-y-0 ![padding:40px_0px_0px_0px] md:mb-12">
          <div className="w-8 h-px bg-primary/30 mx-auto mb-4" />
          <h2 className="font-black text-foreground mb-6 tracking-tighter !text-4xl">
            Een team. Vijf expertises.
          </h2>
          <div className="w-12 h-1 bg-primary mx-auto" />
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-5">
          {services.map((service, index) => <ServiceCard key={service.id} service={service} index={index} />)}
        </div>
      </div>
    </section>;
}